// src/PrivacyPolicy.js
// src/PrivacyPolicy.js
import React from 'react';
import { Container, Typography, Box, Button, List, ListItem, ListItemText } from '@mui/material';

function PrivacyPolicy() {
  return (
    <Container maxWidth="md" sx={{ mt: 5, mb: 5 }}>
      <Typography variant="h4" gutterBottom>
        Privacy Policy
      </Typography>

      <Typography variant="body1" paragraph>
        <strong>Last Updated: 7/16/2024</strong>
      </Typography>

      <Typography variant="body1" paragraph>
        Welcome to <strong>Advise</strong>, a product of <strong>Advisemycampus, LLC</strong> ("Company", "we", "us", "our"). We are committed to protecting your privacy and ensuring that your personal information is handled in a safe and responsible manner. This Privacy Policy outlines how we collect, use, and protect your information when you use our mobile application ("App").
      </Typography>

      <Typography variant="h6" gutterBottom>
        1. Information We Collect
      </Typography>
      <List>
        <ListItem>
          <ListItemText
            primary="Email Address"
            secondary="We collect your email address to enable you to access and use the App. Your email address is used solely for account creation, login, and communication purposes."
          />
        </ListItem>
        <ListItem>
          <ListItemText
            primary="Non-Identifiable Information"
            secondary="We collect data that is not directly tied to your identity. This includes location information, mental health keywords, and usage data (such as the frequency and duration of your interactions with the AI)."
          />
        </ListItem>
      </List>

      <Typography variant="h6" gutterBottom>
        2. How We Use Your Information
      </Typography>
      <List>
        <ListItem>
          <ListItemText
            primary="Account Management"
            secondary="Your email address is used to manage your account, including authentication and customer support."
          />
        </ListItem>
        <ListItem>
          <ListItemText
            primary="Service Improvement"
            secondary="Non-identifiable information is used to enhance the AI's functionality and improve the overall user experience."
          />
        </ListItem>
        <ListItem>
          <ListItemText
            primary="Data Sharing with Fraternal Groups"
            secondary="We share aggregated, non-identifiable data with your fraternity or sorority group. This data includes location information, mental health keywords, and usage statistics. Your specific conversations with the AI are not tied back to your email address or personal identity."
          />
        </ListItem>
      </List>

      <Typography variant="h6" gutterBottom>
        3. Data Security
      </Typography>
      <Typography variant="body1" paragraph>
        We take appropriate security measures to protect your information from unauthorized access, alteration, disclosure, or destruction. These measures include encryption, secure servers, and access controls.
      </Typography>

      <Typography variant="h6" gutterBottom>
        4. Data Retention
      </Typography>
      <Typography variant="body1" paragraph>
        We retain your information for as long as necessary to provide you with our services and for legitimate business purposes. If you wish to delete your account or request that we no longer use your information, please contact us at <strong>help@advisemycampus.com</strong>.
      </Typography>

      <Typography variant="h6" gutterBottom>
        5. User Rights
      </Typography>
      <List>
        <ListItem>
          <ListItemText primary="Access and review the information we hold about you." />
        </ListItem>
        <ListItem>
          <ListItemText primary="Request corrections to inaccurate or incomplete information." />
        </ListItem>
        <ListItem>
          <ListItemText primary="Request deletion of your information, subject to certain legal obligations." />
        </ListItem>
        <ListItem>
          <ListItemText primary="Object to or restrict the processing of your information." />
        </ListItem>
        <ListItem>
          <ListItemText primary="Withdraw your consent to our use of your information at any time." />
        </ListItem>
      </List>
      <Typography variant="body1" paragraph>
        To exercise these rights, please contact us at <strong>help@advisemycampus.com</strong>.
      </Typography>

      <Typography variant="h6" gutterBottom>
        6. Changes to This Privacy Policy
      </Typography>
      <Typography variant="body1" paragraph>
        We may update this Privacy Policy from time to time to reflect changes in our practices or for other operational, legal, or regulatory reasons. We will notify you of any significant changes by posting the new Privacy Policy on our App and updating the "Last Updated" date.
      </Typography>

      <Typography variant="h6" gutterBottom>
        7. Contact Us
      </Typography>
      <Typography variant="body1" paragraph>
        If you have any questions or concerns about this Privacy Policy or our data practices, please contact us at:
      </Typography>
      <Typography variant="body1" paragraph>
        <strong>Advisemycampus, LLC</strong> <br />
        Address: United States Corporation Agents, Inc. 1991 Crocker Rd #600-755, Westlake OH 44145 <br />
        Email: <strong>help@advisemycampus.com</strong>
      </Typography>

      <Box textAlign="center" mt={4}>
        <Button variant="contained" color="primary" href="/">
          Back to Home
        </Button>
      </Box>
    </Container>
  );
}

export default PrivacyPolicy;
